import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaChevronDown, FaChevronRight, FaExternalLinkAlt } from "react-icons/fa";
import Form from 'react-bootstrap/Form';
import Pagination from  '../../../components/Pagination/Pagination';
import Spinner from 'react-bootstrap/Spinner';
import { API } from 'aws-amplify';
import moment from 'moment';

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import DatePickerPopperContainer from '../../../components/DatePickerPopperContainer';

import '../../../styles/compact-filters.css';
import '../../../styles/ops-list.css';
import '../../../components/PageHeader/PageHeader.css';
import PageHeader from '../../../components/PageHeader/PageHeader';
import { useI18n } from '../../../i18n';
import './TaskCompList.css';

import * as localdb from '../../../localdb';

const FILTERS_KEY = "taskCompListFilters";
const PAGE_SIZE_KEY = "taskCompListPageSize";
const PAGE_SIZES = [10, 25, 50];

function formatWhen(value) {
	if (!value) return '';
	const m = moment(value);
	return m.isValid() ? m.format('D MMM YYYY, HH:mm') : String(value);
}

function isUrgentItem(item) {
	return String(item.urgent_fault || '').toLowerCase() === 'urgent';
}

const TaskCompList = (props) => {
	const { t, tStatus, tCatalog, language } = useI18n();
	const [taskList, setTaskList] = useState([]);
    const [dateFrom, setDateFrom] = useState('');
	const [dateTo, setDateTo] = useState('');
	const [dateCompFrom, setDateCompFrom] = useState('');
	const [dateCompTo, setDateCompTo] = useState('');
	const [siteRef,setSiteRef] = useState('');
	const [taskRef,setTaskRef] = useState('');
    const [district, setDistrict] = useState('');
	const [category, setCategory] = useState('');
	const [subcategory, setSubcategory] = useState('');
	const [subcategoryList, setSubcategoryList] = useState([]);
	const [districtList, setDistrictList] = useState([]);
	

	const [isLoading, setIsLoading] = useState(true);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(() => {
		const n = parseInt(localStorage.getItem(PAGE_SIZE_KEY), 10);
		return PAGE_SIZES.includes(n) ? n : 10;
	});
	const [expandedId, setExpandedId] = useState(null);
	const [showMoreFilters, setShowMoreFilters] = useState(false);
	const [search, setSearch] = useState('');

	const [filtersLoaded, setFiltersLoaded] = useState(false);

	const params = { 
        headers: {
			'x-api-key': process.env.REACT_APP_API_KEY,        
			'Accept': 'application/json',
			'Content-Type': 'application/json',
        },
	}

	// Load district
	useEffect(()=>{
		const fetchDistrict = async () => {
			
			const districts = await API.get('settings','/DISTRICTS', params)

			const unique = [...new Set((districts.values || []).filter(Boolean))];
			const list = unique.map((name) => (
				<option key={name} value={name}>{name}</option>
			));

			setDistrictList(list);
		}
		fetchDistrict();	 
	}, []);
	
	const getEndOfDayIso = (dateValue) => {
		let dateToValue = new Date(dateValue);
		dateToValue = dateToValue.setHours(23,59,59,999);
		return new Date(dateToValue).toISOString();
	}

	const buildQuery = () => {
		const query = new URLSearchParams();
		if (dateFrom) query.append('date_from', dateFrom.toISOString());
		if (dateTo) query.append('date_to', getEndOfDayIso(dateTo));
		if (dateCompFrom) query.append('date_comp_from', dateCompFrom.toISOString());
		if (dateCompTo) query.append('date_comp_to', getEndOfDayIso(dateCompTo));
		if (siteRef) query.append('site_ref', siteRef);
		if (taskRef) query.append('task_ref', taskRef);
		if (district) query.append('district', district);
		if (category) query.append('category', category);
		if (subcategory) query.append('subcategory', subcategory);
		return query.toString();
	}

	const fetchTasks = async () => {
		setIsLoading(true);
		const query = buildQuery();
		const endpoint = query ? `/?${query}` : '/';
		const tasks = await API.get('task_comp', endpoint, params);
		
		for (let i = 0; i < tasks.length; i++) {
				switch (tasks[i].task_status) {
					case 'Created': 
						tasks[i].cssTaskStatus = "task_created"; 
						break;
					case 'Accepted': 
						tasks[i].cssTaskStatus = "task_accepted"; 
						break;
					case 'Started': 
						tasks[i].cssTaskStatus = "task_started"; 
						break;
					case 'Completed': 
						tasks[i].cssTaskStatus = "task_completed"; 
						break;
					case 'WIP': 
						tasks[i].cssTaskStatus = "task_wip"; 
						break;
					default: 
						tasks[i].cssTaskStatus = "taskStatus";
				}

				if (tasks[i].sla_attend){
					if (tasks[i].category==="Reactive"){
						tasks[i].sla_attend = tasks[i].sla_attend + ' hrs'
					}else{
						tasks[i].sla_attend = tasks[i].sla_attend + ' days'
					}
				}

		}

		//sort array desc
		tasks.sort((a, b) => (a.date_created > b.date_created) ? 1 : -1)
		tasks.reverse();
		setTaskList(tasks);
		paginate(1);
		setIsLoading(false);
	}

	// Restore filters from localStorage on mount
	useEffect(() => {
		const saved = localStorage.getItem(FILTERS_KEY);
		if (saved) {
			const filters = JSON.parse(saved);
			setDateFrom(filters.dateFrom ? new Date(filters.dateFrom) : '');
			setDateTo(filters.dateTo ? new Date(filters.dateTo) : '');
			setDateCompFrom(filters.dateCompFrom ? new Date(filters.dateCompFrom) : '');
			setDateCompTo(filters.dateCompTo ? new Date(filters.dateCompTo) : '');
			setSiteRef(filters.siteRef || '');
			setTaskRef(filters.taskRef || '');
			setDistrict(filters.district || '');
			setCategory(filters.category || '');
			setSubcategory(filters.subcategory || '');
		}
		setFiltersLoaded(true);
	}, []);

	// Save filters to localStorage whenever they change
	useEffect(() => {
		const filters = {
			dateFrom: dateFrom ? dateFrom.toISOString() : '',
			dateTo: dateTo ? dateTo.toISOString() : '',
			dateCompFrom: dateCompFrom ? dateCompFrom.toISOString() : '',
			dateCompTo: dateCompTo ? dateCompTo.toISOString() : '',
			siteRef,
			taskRef,
			district,
			category,
			subcategory,
		};
		localStorage.setItem(FILTERS_KEY, JSON.stringify(filters));
	}, [dateFrom, dateTo, dateCompFrom, dateCompTo, siteRef, taskRef, district, category, subcategory]);

	useEffect(() => {
		if (!filtersLoaded) return;
		fetchTasks();
	}, [filtersLoaded, dateFrom, dateTo, dateCompFrom, dateCompTo, siteRef, taskRef, district, category, subcategory]);

	const handleClearSearch = () =>{
		setDateFrom('');
		setDateTo('');
		setSiteRef('');
		setTaskRef('');
		setDistrict('');
		setCategory('');
		setSubcategory('');
		setDateCompFrom('');
		setDateCompTo('');
		localStorage.removeItem(FILTERS_KEY);
	}

	const handleCategory = () => {
		setSubcategory('');
		const cat = localdb.CATEGORY;
        let subcat = "";
		for (let i = 0; i < cat.length; i++) {
            if (cat[i].key === category) {
                subcat = cat[i].subcategory.map((item, j) => (
                	<option key={"subcategory"+j} value={item} >{tCatalog(item)}</option>)
                )
            }
        }
		setSubcategoryList(subcat);
	}
	
	useEffect(() => {
		handleCategory();
	}, [category, language]); 

	const visibleList = taskList.filter((item) => {
		const query = search.trim().toLowerCase();
		if (!query) return true;
		return [item.task_ref, item.site_ref, item.site_address, item.fault_description, item.district]
			.join(' ')
			.toLowerCase()
			.includes(query);
	});

	useEffect(() => {
		localStorage.setItem(PAGE_SIZE_KEY, String(pageSize));
		setCurrentPage(1);
	}, [pageSize]);

	const indexOfLastItem = currentPage * pageSize;
	const indexOfFirstItem = indexOfLastItem - pageSize;
	const currentItemList = visibleList.slice(indexOfFirstItem, indexOfLastItem);
	const rangeStart = visibleList.length === 0 ? 0 : indexOfFirstItem + 1;
	const rangeEnd = Math.min(indexOfLastItem, visibleList.length);

	const paginate = (pageNumber) => {
		setCurrentPage(pageNumber);
		setExpandedId(null);
	};

	const toggleExpand = (taskId) => {
		setExpandedId((current) => (current === taskId ? null : taskId));
	};

	const categoryList = localdb.CATEGORY.map((item, i) => (
		<option key={"category"+i} value={item.key}>{tCatalog(item.description)}</option>
	));

	const renderRow = (item) => {
		const open = expandedId === item.taskId;
		const description = item.fault_description || t('tasks.noDescription');
		const placeName = [item.site_address, item.district].filter(Boolean).join(' · ');
		const categoryLine = [tCatalog(item.category), tCatalog(item.type_fault)].filter(Boolean).join(' · ');
		const completedLabel = formatWhen(item.date_completed);
		const createdLabel = formatWhen(item.date_created);

		return (
			<article
				key={item.taskId}
				className={`task-ops-item${open ? ' is-open' : ''}`}
				onClick={() => toggleExpand(item.taskId)}
			>
				<div className="task-ops-row" role="button" tabIndex={0} aria-expanded={open}
					onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleExpand(item.taskId); } }}>
					<div className="task-ops-identity">
						<Link className="task-ops-id" to={`/task_det/${item.taskId}`} onClick={(e) => e.stopPropagation()}>
							#{item.task_ref}
						</Link>
						{item.task_status && <span className={`task-ops-status ${item.cssTaskStatus}`}>{tStatus(item.task_status)}</span>}
						{isUrgentItem(item) && (
							<span className="task-ops-flag" title={t('status.urgent')}>
								<span className="task-ops-flag-dot" aria-hidden="true" />
								{t('status.urgent')}
							</span>
						)}
						{completedLabel && <span className="task-ops-date">{completedLabel}</span>}
					</div>
					<button type="button" className="task-ops-toggle" aria-label={open ? t('tasks.collapse') : t('tasks.expand')}
						onClick={(e) => { e.stopPropagation(); toggleExpand(item.taskId); }}>
						{open ? <FaChevronDown /> : <FaChevronRight />}
					</button>
					<p className="task-ops-title" title={description}>{description}</p>
					<div className="task-ops-meta">
						<div className="task-ops-place">
							{item.site_ref && <span className="task-ops-site-code">{item.site_ref}</span>}
							{placeName && <span className="task-ops-site-name" title={placeName}>{placeName}</span>}
							{categoryLine && <span className="task-ops-cat">· {categoryLine}</span>}
						</div>
						{item.sla_attend && <span className="task-ops-sla">{t('tasks.slaAttendValue', { contract: item.sla_attend })}</span>}
					</div>
				</div>
				{open && (
					<div className="task-ops-detail">
						<div className="task-ops-detail-inner">
							<dl>
								<div className="is-wide">
									<dt>{t('common.address')}</dt>
									<dd>{item.site_address || '—'}{item.district ? ` · ${item.district}` : ''}</dd>
								</div>
								<div className="is-wide">
									<dt>{t('common.description')}</dt>
									<dd>{description}</dd>
								</div>
								<div>
									<dt>{t('common.created')}</dt>
									<dd>{createdLabel || '—'}</dd>
								</div>
								<div>
									<dt>{t('common.completed')}</dt>
									<dd>{completedLabel || '—'}</dd>
								</div>
								<div>
									<dt>{t('common.classification')}</dt>
									<dd>{item.urgent_fault || '—'}</dd>
								</div>
								<div>
									<dt>{t('tasks.slaAttend')}</dt>
									<dd>{item.sla_attend || '—'}</dd>
								</div>
							</dl>
							<div className="task-ops-actions">
								<Link className="task-ops-open" to={`/task_det/${item.taskId}`} onClick={(e) => e.stopPropagation()}>
									<FaExternalLinkAlt /> {t('tasks.openTask')}
								</Link>
							</div>
						</div>
					</div>
				)}
			</article>
		);
	};

	return (
	<div className="TaskCompList">
		<div>
			<PageHeader
				title={t('pages.tasksCompleted.title')}
				subtitle={t('pages.tasksCompleted.subtitle')}
				breadcrumbs={[
					{ label: t('nav.tasks'), path: '/tasks' },
					{ label: t('nav.completed') },
				]}
				count={!isLoading ? visibleList.length : undefined}
				countLabel={t('common.tasks')}
			/>
			<div className="task-ops">
				<Form className="compact-filters task-ops-filters" onSubmit={(e) => e.preventDefault()}>
					<div className="task-ops-filters-main">
						<Form.Control className="task-ops-search" size="sm" placeholder={t('tasks.searchPlaceholder')} value={search} onChange={(e) => { setSearch(e.target.value); setCurrentPage(1); }} />
						<Form.Control as="select" size="sm" value={district} onChange={(e) => setDistrict(e.target.value)}>
							<option value="">{t('common.district')}</option>
							{districtList}
						</Form.Control>
						<Form.Control as="select" size="sm" value={category} onChange={(e) => setCategory(e.target.value)}>
							<option value="">{t('common.category')}</option>
							{categoryList}
						</Form.Control>
						<button type="button" className={`task-ops-more${showMoreFilters ? ' is-open' : ''}`} aria-expanded={showMoreFilters} onClick={() => setShowMoreFilters((v) => !v)}>{t('common.moreFilters')}</button>
						<button type="button" className="task-ops-reset" onClick={handleClearSearch}>{t('common.reset')}</button>
					</div>
					{showMoreFilters && (
						<div className="task-ops-filters-panel">
							<Form.Control size="sm" placeholder={t('tasks.taskRef')} value={taskRef} onChange={(e) => setTaskRef(e.target.value)} />
							<Form.Control size="sm" placeholder={t('tasks.siteRef')} value={siteRef} onChange={(e) => setSiteRef(e.target.value)} />
							<Form.Control as="select" size="sm" value={subcategory} onChange={(e) => setSubcategory(e.target.value)} disabled={!category}>
								<option value="">{t('common.subcategory')}</option>
								{subcategoryList}
							</Form.Control>
							<DatePicker selected={dateFrom || null} onChange={setDateFrom} className="form-control form-control-sm" placeholderText={t('tasks.createdFrom')} dateFormat="dd/MM/yyyy" isClearable popperContainer={DatePickerPopperContainer} />
							<DatePicker selected={dateTo || null} onChange={setDateTo} className="form-control form-control-sm" placeholderText={t('tasks.createdTo')} dateFormat="dd/MM/yyyy" isClearable popperContainer={DatePickerPopperContainer} />
							<DatePicker selected={dateCompFrom || null} onChange={setDateCompFrom} className="form-control form-control-sm" placeholderText={t('tasks.completedFrom')} dateFormat="dd/MM/yyyy" isClearable popperContainer={DatePickerPopperContainer} />
							<DatePicker selected={dateCompTo || null} onChange={setDateCompTo} className="form-control form-control-sm" placeholderText={t('tasks.completedTo')} dateFormat="dd/MM/yyyy" isClearable popperContainer={DatePickerPopperContainer} />
						</div>
					)}
				</Form>

				<div className="task-ops-panel" aria-busy={isLoading}>
					{isLoading ? (
						<div className="loading-container">
							<div className="loading-content">
								<Spinner animation="border" role="status" variant="primary" className="loading-spinner" />
								<div className="loading-text">{t('tasks.loading')}</div>
							</div>
						</div>
					) : (
						<>
							<div className="task-ops-legend" aria-hidden="true">{t('tasks.legendCompleted')}</div>
							<div className="task-ops-list">
								{currentItemList.length === 0 ? (
									<div className="task-ops-empty">{t('tasks.emptyCompleted')}</div>
								) : currentItemList.map(renderRow)}
							</div>
							<div className="task-ops-footer">
								<p className="task-ops-range">{t('tasks.showing', { start: rangeStart, end: rangeEnd, total: visibleList.length })}</p>
								<div className="task-ops-pagesize">
									<label htmlFor="task-comp-pagesize">{t('common.rows')}</label>
									<select id="task-comp-pagesize" value={pageSize} onChange={(e) => setPageSize(Number(e.target.value))}>
										{PAGE_SIZES.map((size) => <option key={size} value={size}>{size}</option>)}
									</select>
								</div>
								<Pagination sizePerPage={pageSize} currentPage={currentPage} totalSize={visibleList.length} changeCurrentPage={paginate} theme="bootstrap" />
							</div>
						</>
					)}
				</div>
			</div>
		</div>
	</div>
	);
}

export default TaskCompList;
